interface SectionToggleProps {
    enabled: boolean;
    onToggle: () => void;
    size?: 'sm' | 'md';
    disabled?: boolean;
    /** Lets a `<label htmlFor>` associate with the switch for its accessible name. */
    id?: string;
}

function SectionToggle({ enabled, onToggle, size = 'md', id, disabled }: SectionToggleProps) {
    const track = size === 'sm' ? 'h-4 w-7' : 'h-5 w-9';
    const knob = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';
    const knobShift = enabled
        ? size === 'sm'
            ? 'translate-x-3'
            : 'translate-x-4'
        : 'translate-x-0';

    return (
        <button
            id={id}
            type="button"
            role="switch"
            aria-checked={enabled}
            disabled={disabled}
            onClick={onToggle}
            className={`relative inline-flex ${track} flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed ${
                enabled ? 'bg-gray-800' : 'bg-gray-300'
            }`}
        >
            <span
                className={`inline-block ${knob} transform rounded-full bg-white shadow transition-transform duration-200 ${knobShift}`}
            />
        </button>
    );
}

export { SectionToggle };
